var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardArrowCyan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 10,
    fill: "#6FE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M14.33 10.33C14.5122 10.1477 14.5122 9.85226 14.33 9.67002L11.3601 6.70017C11.1779 6.51792 10.8824 6.51792 10.7002 6.70017C10.5179 6.88241 10.5179 7.17789 10.7002 7.36013L13.34 10L10.7002 12.6399C10.5179 12.8221 10.5179 13.1176 10.7002 13.2998C10.8824 13.4821 11.1779 13.4821 11.3601 13.2998L14.33 10.33ZM7 10V10.4667L14 10.4667V10V9.53333L7 9.53333V10Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrowCyan);
export default __webpack_public_path__ + "static/media/card-arrow-cyan.8c8970de57a09b8f16a6352b7ea37ede.svg";
export { ForwardRef as ReactComponent };